const GET_COORDINATES = 'publicador-profesionales/ducks/locationStep/GET_COORDINATES';
const GET_COORDINATES_FAILED = 'publicador-profesionales/ducks/locationStep/GET_COORDINATES_FAILED';
const GET_COORDINATES_COMPLETED = 'publicador-profesionales/ducks/locationStep/GET_COORDINATES_COMPLETED';

const GET_CEP = 'publicador-profesionales/ducks/locationStep/GET_CEP';
const GET_CEP_FAILED = 'publicador-profesionales/ducks/locationStep/GET_CEP_FAILED';
const GET_CEP_COMPLETED = 'publicador-profesionales/ducks/locationStep/GET_CEP_COMPLETED';

const GET_LOCATION = 'publicador-profesionales/ducks/locationStep/GET_LOCATION';
const GET_LOCATION_COMPLETED = 'publicador-profesionales/ducks/locationStep/GET_LOCATION_COMPLETED';

const SET_ADDRESS = 'publicador-profesionales/ducks/locationStep/SET_ADDRESS';
const SET_SELECTED_PROVINCE = 'publicador-profesionales/ducks/locationStep/SET_SELECTED_PROVINCE';
const SET_SELECTED_CITY = 'publicador-profesionales/ducks/locationStep/SET_SELECTED_CITY';
const SET_SELECTED_DISTRICT = 'publicador-profesionales/ducks/locationStep/SET_SELECTED_DISTRICT';
const SET_SELECTED_SUBDISTRICT = 'publicador-profesionales/ducks/locationStep/SET_SELECTED_SUBDISTRICT';
const SET_CEP = 'publicador-profesionales/ducks/locationStep/SET_CEP';
const RESET_CEP_ERROR = 'publicador-profesionales/ducks/locationStep/RESET_CEP_ERROR';
const SET_ADDRESS_COMPLEMENT = 'publicador-profesionales/ducks/locationStep/SET_ADDRESS_COMPLEMENT';
const SET_POSTALCODE = 'publicador-profesionales/ducks/locationStep/SET_POSTALCODE';

const RESET_VALUES = 'publicador-profesionales/ducks/locationStep/RESET_VALUES';
const RESET_INFO = 'publicador-profesionales/ducks/locationStep/RESET_INFO';
const SET_EDITED = 'publicador-profesionales/ducks/locationStep/SET_EDITED';
const SET_EDIT_VALUES = 'publicador-profesionales/ducks/locationStep/SET_EDIT_VALUES';
const GET_FORM_VALUES = 'publicador-profesionales/locationStep/GET_FORM_VALUES';
const GET_FORM_VALUES_COMPLETED = 'publicador-profesionales/locationStep/GET_FORM_VALUES_COMPLETED';
const GET_FORM_VALUES_FAILED = 'publicador-profesionales/locationStep/GET_FORM_VALUES_FAILED';

const SAVE_STEP1_MODULE_2 = 'publicador-profesionales/ducks/locationStep/SAVE_MODULE_2';

const SET_VISIBILITY = 'publicador-profesionales/ducks/locationStep/SET_VISIBILITY';
const SET_COORDINATES = 'publicador-profesionales/ducks/locationStep/SET_COORDINATES';
const RESET_COORDINATES = 'publicador-profesionales/ducks/locationStep/RESET_COORDINATES';

export {
  GET_COORDINATES,
  GET_COORDINATES_FAILED,
  GET_COORDINATES_COMPLETED,
  GET_LOCATION,
  GET_LOCATION_COMPLETED,
  SET_ADDRESS,
  SET_SELECTED_PROVINCE,
  SET_SELECTED_CITY,
  SET_SELECTED_DISTRICT,
  SET_SELECTED_SUBDISTRICT,
  SET_VISIBILITY,
  RESET_VALUES,
  SET_EDITED,
  SAVE_STEP1_MODULE_2,
  RESET_INFO,
  SET_EDIT_VALUES,
  GET_FORM_VALUES,
  GET_FORM_VALUES_COMPLETED,
  GET_FORM_VALUES_FAILED,
  SET_COORDINATES,
  GET_CEP,
  GET_CEP_FAILED,
  GET_CEP_COMPLETED,
  SET_CEP,
  SET_ADDRESS_COMPLEMENT,
  SET_POSTALCODE,
  RESET_CEP_ERROR,
  RESET_COORDINATES
};
